module.exports = __webpack_public_path__ + "img/selected0-min.90110e9d.png";